// extracted by css-extract-rspack-plugin
export default {"marker":"j5ZU6id40yExlB93"};